import BaseViewModel from "./BaseViewModel";

class BoolControlViewModel extends BaseViewModel {

	ValidateMandatory = () => {
		return !this.IsMandatory || this.getValue() !== undefined;
	};

	override getValue = () => !!this.Value;

	override getSimpleFormatXmlTagName = () => 'Bool';

};

export default BoolControlViewModel;
